


import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPublicStats } from '../services/api';

const SERVICES = [
  { title: 'Free Consultation', desc: 'A no-cost first conversation to understand your workplace matter.' },
  { title: 'Case Review', desc: 'Our paralegals assess the merits and next steps of your case.' },
  { title: 'Once-Off Case Assistance', desc: 'Focused support for a single matter for a once-off contribution of R380.' },
  { title: 'Membership', desc: 'Ongoing protection, guidance and priority support for members.' },
  { title: 'CCMA Preparation', desc: 'We help you prepare documents and arguments for CCMA proceedings.' },
  { title: 'Labour Court Accompaniment', desc: 'Support and accompaniment through labour court processes.' },
];

export default function Home() {
  const [stats, setStats] = useState({ workersAssisted: 0, activeMembers: 0, provincesReached: 9 });

  useEffect(() => {
    getPublicStats()
      .then((res) => setStats(res.data))
      .catch(() => {});
  }, []);

  return (
    <div>
      {/* HERO */}
      <section
        className="dark-section hero-section"
        style={{ padding: '96px 0 80px', '--hero-image': "url('/image/Justice.jpg')" }}
      >
        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <span className="eyebrow">The Spear Of Workers</span>
          <h1 style={{ marginTop: 16, maxWidth: 760 }}>
            Standing beside every worker facing an unfair fight.
          </h1>
          <p style={{ maxWidth: 560, fontSize: '1.1rem' }}>
            Singumkhonto Wabasebenzi NPC provides workers' rights education, paralegal
            guidance, and case support to workers across South Africa — from first
            consultation to a resolved matter.
          </p>
          <div style={{ display: 'flex', gap: 16, marginTop: 32, flexWrap: 'wrap' }}>
            <Link to="/register" className="btn btn-gold">Become a Member</Link>
            <a href="https://wa.me/27714505692" target="_blank" rel="noopener noreferrer" className="btn btn-outline">
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="section-tight" style={{ background: '#111', borderTop: '1px solid #2a2a2a' }}>
        <div className="container grid grid-3">
          <div>
            <div className="stat-number" style={{ color: 'var(--color-gold)' }}>{stats.workersAssisted}+</div>
            <div className="stat-label" style={{ color: '#b8b8b8' }}>Workers Assisted</div>
          </div>
          <div>
            <div className="stat-number">{stats.activeMembers}+</div>
            <div className="stat-label" style={{ color: '#b8b8b8' }}>Active Members</div>
          </div>
          <div>
            <div className="stat-number">{stats.provincesReached}</div>
            <div className="stat-label" style={{ color: '#b8b8b8' }}>Provinces Reached</div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="section">
        <div className="container">
          <span className="eyebrow">How It Works</span>
          <h2 style={{ marginTop: 12 }}>From first message to a resolved matter</h2>
          <div className="grid grid-4" style={{ marginTop: 32 }}>
            {[
              ['1', 'Reach Out', 'Contact us via WhatsApp or register online in minutes.'],
              ['2', 'Free Consultation', 'We review your matter at no cost, with no obligation.'],
              ['3', 'Case Assistance', 'A once-off R380 contribution unlocks full case support.'],
              ['4', 'Ongoing Membership', 'Join as a member for continued protection and guidance.'],
            ].map(([num, title, desc]) => (
              <div className="card" key={num}>
                <div style={{ color: 'var(--color-gold)', fontFamily: 'var(--font-display)', fontSize: '1.5rem' }}>{num}</div>
                <h3>{title}</h3>
                <p>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SERVICES OVERVIEW */}
      <section className="section" style={{ background: '#f7f5ef' }}>
        <div className="container">
          <span className="eyebrow">Our Services</span>
          <h2 style={{ marginTop: 12 }}>Support at every stage of your matter</h2>
          <div className="grid grid-3" style={{ marginTop: 32 }}>
            {SERVICES.map((s) => (
              <div className="card" key={s.title}>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 32 }}>
            <Link to="/services" className="btn btn-outline-dark">View All Services</Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="dark-section section">
        <div className="container" style={{ textAlign: 'center' }}>
          <h2>You don't have to face this alone.</h2>
          <p style={{ maxWidth: 500, margin: '0 auto 24px' }}>
            Speak to us today for a free, confidential consultation about your workplace matter.
          </p>
          <Link to="/register" className="btn btn-gold">Get Started</Link>
        </div>
      </section>
    </div>
  );
}
